import * as React from 'react';
import ImageLoader from './image_loader';
import { ALL_ICONS } from '../icons/map';
import * as classNames from 'classnames';

export const ICONS_LIST = Object.keys(ALL_ICONS);

interface IProps {
  name: typeof ICONS_LIST[number];
  /* Set to false (default) to allow the icon to take up the full width of the parent container
    Set to true to use the icon inline with text. The parent container's font size will control the size. */
  inline?: boolean;
  title?: string;
  nativeSize?: boolean;
}

export default function UIIcon({ name, title, inline = false, nativeSize = false }: IProps) {
  const filepath = ALL_ICONS[name];

  if (!filepath) { return null; }

  const classes = classNames('ui-icon', {
    'ui-icon--inline': inline,
    'ui-icon--native-size': nativeSize,
  });

  return (
    <span className={classes}>
      <ImageLoader
        src={filepath}
        title={title}
        embedInline
      />
    </span>
  );
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/components/ui_icon.tsx